import { render, staticRenderFns } from "./ListCodigosPromocionais.vue?vue&type=template&id=66327699&"
import script from "./ListCodigosPromocionais.vue?vue&type=script&lang=js&"
export * from "./ListCodigosPromocionais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports